<template>
  <div style="overflow-x:hidden;overflow-y: hidden">
    <div class="to-top" @click="toTop" v-if="showToTop" ><i class="el-icon-arrow-up" style="line-height: 1.8vw"></i></div>
    <NavHeader
      :status="{
        page:'solution',
        produce:false,
        solution:true
      }"
      @switchSolutionPage="switchPage"
    />
    <div class="main"
         ref="solution">
      <div v-if=xr class="solution-board">
        <div class="title-back "><h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">VR创新实验室解决方案</h1></div>
        <div class="solution-back-img1"></div>
        <div style="width: 100vw;">
          <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;">
            <div class="xr-img-left"></div>
            <div style="margin-top: 15vw;width: 30vw;margin-right: 10vw">
              <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍</p>
              <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
              <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
                以实验软件为核心，以VR穿戴式交互设备为支撑硬件，为学生和老师打造全息/虚拟现实VR/增强现实AR/混合现实MR技术为基础的“XR联合创新教室”打造沉浸式的智慧课堂，增强学生在现实与虚拟的交互，让学生置身其中去学习和体验，开阔学生眼界，激发学生探索科学的兴趣。
              </p>
              <div class="solution-introduce-btn">
                <i class="el-icon-right" style="color:#5eb2f7;background-color: white;border-radius: 50%;font-weight: 600;margin-right: 5px"></i>联系我们
              </div>

            </div>
          </div>
        </div>
        <div class="solution-back-img2"></div>
        <div style="width: 100vw;height: 30vw;margin: auto">
          <div class="solution-back-img3"></div>
        </div>
        <div style="height: 32vw;width: 100vw;">
          <h1 style="margin: 5vw auto 0vw;text-align: center">方案软硬件配置</h1>
          <div style="margin: 2vw auto;height: 5px;width: 2vw;background-color: black;border-radius: 5px">
          </div>
          <div style="margin:0 auto;width: 60vw;height: 20vw;">
            <div class="solution-back-img4" >

            </div>
          </div>

        </div>
      </div>











      <div v-if=create class="solution-board">
        <div class='solution-back-img5'></div>
        <div class="title-back">
          <h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">创客空间解决方案</h1>
        </div>

        <div style="width: 100vw;" >
          <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;">
            <div class="solution-create-left"></div>
            <div style="margin-top: 10vw;width: 30vw;margin-right: 20vw">
              <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍</p>
              <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
              <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
                搭载桌面VR一体机、MR交互系统、出屏3D等软硬件，专注信息技术与教育教学的深度融合，提供深度交互式学习环境，打造融合创新式实验室，提高学生视、听、说多维度的参与度，让抽象的概念、理论更为具体、形象。
              </p>
              <div class="solution-introduce-btn">
                <i class="el-icon-right" style="color:#1a8cfe;background-color: white;border-radius: 50%"></i>联系我们
              </div>

            </div>
          </div>
        </div>
        <h1 style="margin-top: 5vw;text-align: center;font-weight: 600">产品特点</h1>
        <div style="margin: 2vw auto 3vw;height: 5px;width: 2vw;background-color: black;border-radius: 5px"></div>
        <div class="solution-back-img6"></div>
        <div style="width: 100vw">
          <div class="create-img1"></div>
        </div>
        <h1 style="margin-top: 5vw;text-align: center;font-weight: 600">方案软硬件配置</h1>
        <div style="margin: 2vw auto 3vw;height: 5px;width: 2vw;background-color: black;border-radius: 5px"></div>
        <div style="height: 22vw;width: 60vw;margin: auto">
          <div class="solution-back-img4" >

          </div>
        </div>
      </div>




      <div v-if=math class="solution-board">
        <div class="title-back"><h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">数字化探究实验室解决方案</h1></div>
        <div class="solution-back-img8"></div>
        <div class="solution-back-img7"></div>
        <div style="width: 100vw">
          <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;">
            <div class="math-img1"></div>
            <div style="margin-top: 10vw;width: 30vw;margin-right: 18vw">
              <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍</p>
              <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
              <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
                实验软件融入传统理化生实验课堂，将虚拟仿真技术完美融合到课堂，实验现象科学准确，通过实验软件进行演示教学，帮助学生在传统实验器材中操作中熟悉实验，辅助老师和学生的教与学，以教促学、以学促练，从而达到实验教学目标。
              </p>
              <div class="solution-introduce-btn">
                <i class="el-icon-right" style="color:#1a8cfe;background-color: white;border-radius: 50%"></i>联系我们
              </div>

            </div>
          </div>

        </div>
        <div style="width: 100vw;height: 30vw;margin-top: 2vw">
          <div class="math-img2"></div>
        </div>
        <div style="height: 32vw;width: 100vw;">
          <h1 style="margin-top: 10vw;text-align: center">方案软硬件配置</h1>
          <div style="margin: 2vw auto;height: 5px;width: 2vw;background-color: black;border-radius: 5px">

          </div>
          <div class="solution-math-img" >
          </div>
        </div>
      </div>








      <div v-if=physical class="solution-board">
        <div class="title-back"><h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">理化生实操考试综合解决方案</h1></div>
        <div class="solution-back-img8"></div>
        <div class="solution-back-img7"></div>
        <div style="width: 100vw;height: 20vw">
          <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;">
            <div class="physical-img2"></div>
            <div style="margin-top: 10vw;width: 30vw;margin-right: 18vw">
              <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍</p>
              <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
              <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
                实操考试由“教考评一体化"平 台和考试实验设备两大部分组成，将虚拟仿真实验系统部署到实操考试实验室，帮助老师快速组织进行实验练习和实验考试，实操考试实验室也可作为理化生考场去使用。
              </p>
              <div class="solution-introduce-btn">
                <i class="el-icon-right" style="color:#1a8cfe;background-color: white;border-radius: 50%"></i>联系我们
              </div>

            </div>
          </div>
        </div>
        <div style="width: 100vw;height: 30vw;margin-top: 10vw">
          <div class="physical-img1"></div>
        </div>
        <div style="height: 32vw;width: 100vw;">
          <h1 style="margin-top: 10vw;text-align: center">方案软硬件配置</h1>
          <div style="margin: 2vw auto;height: 5px;width: 2vw;background-color: black;border-radius: 5px">

          </div>
          <div class="solution-physical-img" >
          </div>
        </div>
      </div>



      <div v-if=classroom class="solution-board">
        <div class="classroom-back"></div>
        <div class="title-back"><h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">常态化解决方案</h1></div>
        <div class="classroom-img1"></div>
        <div style="width: 100vw;height:30vw;display: flex;flex-wrap: nowrap">
          <div class="classroom-img2"></div>
          <div style="margin-left: 0;width: 25vw;height:14vw;margin-top: 10vw">
            <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍（普通教室）</p>
            <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
            <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
              以常态化教室为基础，实验软件为核心，从教学实践出发，贴近老师教学需求。通过利用虚拟仿真技术与多学科深度融合，满足课前、课中、课后多场景的教学需求，为老师和学生提供了教与学、学与练的互动学习场景。
            </p>
            <div class="solution-introduce-btn">
              <i class="el-icon-right" style="color:#1a8cfe;background-color: white;border-radius: 50%"></i>联系我们
            </div>
          </div>
        </div>


        <div style="width: 100vw;height:30vw;display: flex;flex-wrap: nowrap">

          <div style="margin-left: 20vw;width: 25vw;height:14vw;margin-top: 5vw">
            <p style="font-weight: 800;letter-spacing: 2px;font-size: 1vw">方案介绍（机房教室）</p>
            <div style="width: 2vw;height: 0.2vw;background-color: black;margin-bottom: 0.5vw;margin-top: 0.5vw;border-radius: 4px">&nbsp;</div>
            <p class="solution-introduce" style="font-size: 0.8vw;line-height: 1.6vw;margin-bottom: 1vw">
              以多媒体云端服务器为基础，实验室软件为核心，打破时间和地域限制，通过客户端在线访问，服务器部署满足老师展示，学生练习、模拟考试多用途教学需求，帮助老师快速组织学生进行实验探究学习，激发学生学习兴趣。
            </p>
            <div class="solution-introduce-btn">
              <i class="el-icon-right" style="color:#1a8cfe;background-color: white;border-radius: 50%"></i>联系我们
            </div>
          </div>
          <div class="media-img-copy"></div>
        </div>
        <div style="width: 100vw;margin-top: 0;height: 20vw">
          <div class="classroom-img3"></div>
        </div>
        <div style="height: 32vw;width: 100vw;margin-top: 10vw">
          <h1 style="margin-top: 5vw;text-align: center">方案软硬件配置</h1>
          <div style="margin: 2vw auto;height: 5px;width: 2vw;background-color: black;border-radius: 5px">
          </div>
          <div class="classroom-img4"></div>
        </div>
      </div>
      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>

</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
export default {
  name: 'solution',
  components: { NavHeader,Footer },
  data(){
    return{
      xr:this.$route.query.title==='xr',
      create:this.$route.query.title==='create',
      math:this.$route.query.title==='math',
      physical:this.$route.query.title==='physical',
      classroom:this.$route.query.title==='classroom',
      activeCard:'xr',
      showToTop:false,
    }
  },
  mounted () {
    if(window){
      window.addEventListener('mousewheel',(e)=>{
        if(e.pageY>1500){
          this.showToTop=true
        }
        else{
          this.showToTop=false
        }
      })
    }
  },
  beforeDestroy () {
    if(window){
      window.removeEventListener('mousewheel',()=>{
        console.log('remove')
      })
    }

  },
  methods:{
    switchPage (page) {
      this.xr=false
      this.classroom=false
      this.math=false
      this.create=false
      this.physical=false
      this[page]=true
    },
    toTop(){
      this.showToTop=false
      $('body,html').animate({
          scrollTop: 0
        },
        500);

    },
  }
}
</script>

<style scoped>


p {
  font-family: "Microsoft YaHei UI Light";
  line-height: 2rem;
  letter-spacing: 1px;
}

.header {
  position: relative;
  width: 100vw;
  height: 42vh;
}

.main {
  width: 100vw;
  margin-top: 25vw;
  margin-bottom: 0;
  position: relative;

}




@media screen and (max-width: 1200px) {

  .solution-introduce-btn{
    cursor: pointer;
    border-radius:5px;
    color: white;
    background-color: #72d5ff;
    height: 1.5vw;
    width: 7vw;
    font-size: 0.7rem;
    line-height: 1.5vw;
    text-align: center;
    white-space: nowrap;
  }
  .solution-introduce{
    font-size: 0.7rem;
    line-height: 1.4rem;
  }

}
.title-back{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/标题背景.png");
  width: 100vw;
  height: 4vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: auto;
  white-space: nowrap;
  text-align: center;

}
.footer-img{
  height: 5vw;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/连接商业价值，融合价值创新.png");
}

.xr-img-left {
  width: 50vw;
  margin-left: 2vw;
  margin-right: 2vw;
  margin-top: 0;
  height: 40vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创新实验室场景.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-board{
  position: relative;

}
.solution-back-img1{
  position: absolute;
  width: 55vw;
  height: 26vw;
  top:-5vw;
  right:0;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创新实验室背景.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-back-img2{
  position: absolute;
  width: 100vw;
  height: 83vw;
  top:44vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创新实验室特点背景.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.solution-back-img3{
  width: 62.5vw;
  height: 20vw;
  margin: 5vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/5G+XR创新实验室特点.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-back-img4{
  width: 52vw;
  height: 12vw;
  margin-top: 5vw ;
  margin-left: 3.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/VR创新实验室软硬件.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-back-img5{
  position: absolute;
  width: 78vw;
  height: 26.5vw;
  top:4.5vw;
  right:0.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创客空间方案介绍背景.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}
.solution-back-img6{
  position: absolute;
  width: 100vw;
  height: 130vw;
  top:-5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/解放方案特点背景通用1.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-create-left{
  width: 35vw;
  height: 20vw;
  margin-top: 5vw;
  margin-left: 20vw;
  margin-right: 2vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创客空间案例.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.create-img1{
  width: 63vw;
  height: 10vw;
  margin:8vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/创客空间特点.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-back-img7{
  position: absolute;
  width: 100vw;
  height: 130vw;
  top:-5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/解放方案特点背景通用.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-back-img8{
  position: absolute;
  width: 85vw;
  height: 37vw;
  top:-5vw;
  right: 0;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/方案介绍背景通用1.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}
.math-img1{
  width: 32vw;
  height: 20vw;
  margin-top: 8vw;
  margin-left: 18vw;
  margin-right: 1.8vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室电脑.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.math-img2{
  width: 62vw;
  height: 40vw;
  margin:0vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室特点.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.physical-img1{
  width: 62vw;
  height: 40vw;
  margin:8vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室特点.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-math-img{
  width: 55vw;
  height: 12vw;
  margin: 5vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室软硬件.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solution-physical-img{
  width: 55vw;
  height: 12vw;
  margin: 5vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室软硬件.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.classroom-img1{
  position: absolute;
  width: 85vw;
  height: 37vw;
  top:2vw;
  right: 0;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/方案介绍背景通用.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}
.classroom-img2{
  width: 35vw;
  height: 14vw;
  margin-left: 17vw;
  margin-right: 3vw;
  margin-top: 10vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/常态化教室电子白板.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.media-img-copy{
  width: 35vw;
  height: 14vw;
  margin-left: 3vw;
  margin-right: 17vw;
  margin-top: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/多媒体机房电脑.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.classroom-back{
  position: absolute;
  width: 100vw;
  height: 130vw;
  top:-5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/解放方案特点背景通用1.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.classroom-img3{
  width: 63vw;
  height: 22vw;
  margin: auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/常态化教室特点.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.classroom-img4{
  width: 58vw;
  height: 10vw;
  margin: 5vw auto;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/常态化教室软硬件.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.solution-introduce-btn{
  cursor: pointer;
  border-radius:5px;
  color: white;
  background-color: #72d5ff;
  height: 1.5vw;
  line-height: 1.5vw;
  text-align: center;
  width: 7vw;
}
.to-top{
  position: fixed;
  display: flex;
  flex-direction: column;
  float: right;
  top:40vw;
  right: 3vw;
  text-align: center;
  font-size: 1vw;
  cursor: pointer;
  z-index: 999;
  width:2vw;
  height: 2vw;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
.physical-img2{
  width: 32vw;
  height: 20vw;
  margin-top: 8vw;
  margin-left: 18vw;
  margin-right: 1.8vw;
  background-image: url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室电脑.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
